/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {CampaignTemplatesInner} from './CampaignTemplatesInner';

/**
 * The CampaignTemplates model module.
 * @module model/CampaignTemplates
 * @version 1.0.0
 */
export class CampaignTemplates extends Array {
  /**
   * Constructs a new <code>CampaignTemplates</code>.
   * @alias module:model/CampaignTemplates
   * @class
   * @extends Array
   */
  constructor() {
    super();
  }

  /**
   * Constructs a <code>CampaignTemplates</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CampaignTemplates} obj Optional instance to populate.
   * @return {module:model/CampaignTemplates} The populated <code>CampaignTemplates</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CampaignTemplates();
      ApiClient.constructFromObject(data, obj, 'CampaignTemplatesInner');
    }
    return obj;
  }
}
